import { render, staticRenderFns } from "./ListaArquivos.vue?vue&type=template&id=5a69e02e&scoped=true&"
import script from "./ListaArquivos.vue?vue&type=script&lang=js&"
export * from "./ListaArquivos.vue?vue&type=script&lang=js&"
import style0 from "./ListaArquivos.vue?vue&type=style&index=0&id=5a69e02e&scoped=true&lang=css&"
import style1 from "./ListaArquivos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a69e02e",
  null
  
)

export default component.exports